import React from 'react';
import {  KoText } from 'packages';
import KoIcon from '@kwapio/icons';
import styles from './iconGallery.module.scss';
const iconNames = [
  
  "BillsOutlined",
  "EstimatesOutlined",
  "TrackOutlined",
  "ExpensesOutlined",
  "ClaimsOutlined",
  "ProjectsOutlined",
  "ProfileUpdateOutlined",
  "EpicOutlined",
  "ChangeTemplateOutlined",
  "WorkspaceOutlined",
  "NoWorkSpaceOutlined",
  "DownArrowOutlined",
  "StopHandOutlined",
  "TestCasesOutlined",
  "SupportPortalOutlined",
  "MileStoneOutlined",
  "EstimationOutlined",
  "ListOutlined",
  "AddtoGroupsOutlined",
  
  "DocumentsOutlined",
  "InvoicesOutlined",
  "InventoryOutlined",
  "OrdersOutlined",
  "ShippingOutlined",
  "ReportsOutlined",
  "GlobeOutlined",
  "WorkflowOutlined",
  "ActivityOutlined",
  "HrOutlined",
  "NotificationAlertOutlined",
  "AssetsOutlined",
  "SecurityOutlined",
  "RestoreOutlined",
  "MarketingOutlined",
  "FileImageOutlined",
  "CalendarOutlined",
  "MoonOutlined",
  "SunOutlined",
  "DeploymentOutlined",
  "SuspendOutlined",
  "ActivateOutlined",
  "EventsOutlined",
  "SalesOutlined",
  "ClientsOutlined",
  "TicklineOutlined",
  "OrgOutlined",
  "SettingsOutlined",
  "PollOutlined",
  "SharedOutlined",
  "InfoOutlined",
  "TickOutlined",
  "PlaneOutlined",
  "EmpIdOutlined",
  "EnvOutlined",
  "UploadOutlined",
  "CopyOutlined",
  "LogOutlined",
  "TotalUsersOutlined",
  "ActiveUseresOutlined",
  "InactiveUsersOutlined",
  "TotalGroupsOutlined",
  "InvitedOutlined",
  "RequestedOutlined",
  "ArrowLeftOutlined",
  "ArrowRightOutlined",
  "RowOpenOutlined",
  "ModulesOutlined",
  "ComponentsOutlined",
  "MeetingsOutlined",
  "QuickViewOutlined",
  "RowCloseOutlined",
  "BoldOutlined",
  "DescendingOutlined",
  "AscendingOutlined",
  "SortOutlined",
  "BugOutlined",
  "ChangerequestOutlined",
  "ChatOutlined",
  "CloseOutlined",
  "CloudDownloadOutlined",
  "EditOutlined",
  "MoveToOutlined",
  "ShareOutlined",
  "CodeOutlined",
  "DeleteOutlined",
  "StarOutlined",
  "DocOutlined",
  "IssuesOutlined",
  "DownloadOutlined",
  "FeaturerequrstOutlined",
  "ImagesOutlined",
  "ImprovementOutlined",
  "ItalicOutlined",
  "UnderlineOutlined",
  "LinkOutlined",
  "VerticalMenuOutlined",
  "MenuOutlined",
  "NotificationOutlined",
  "OpenOutlined",
  "PdfOutlined",
  "PinOutlined",
  "PlayingAudioOutlined",
  "PlayWhiteOutlined",
  "PointsOutlined",
  "QueryOutlined",
  "SendOutlined",
  "SmileyOutlined",
  "AtOutlined",
  "SearchDocOutlined",
  "DragOutlined",
  "ParagraphOutlined",
  "NumbersOutlined",
  "DropdownOutlined",
  "CheckboxOutlined",
  "ChoiceOutlined",
  "LineOutlined",
  "WebOutlined",
  "CountryOutlined",
  "CustomerOutlined",
  "UserSettingsOutlined",
  "YesnoOutlined",
  "ImportOutlined",
  "ExportOutlined",
  "ResetOutlined",
  "AudioOutlined",
  "ScrumSprintOutlined",
  "BillableOutlined",
  "NonBillableOutlined",
  "ReplyOutlined",
  "FolderLine",
  "StoryOutlined",
  "SubtaskOutlined",
  "RefreshOutlined",
  "ChartOutlined",
  "SupportOutlined",
  "TableOutlined",
  "TaskOutlined",
  "VideoFileOutlined",
  "PPTFileOutlined",
  "XLSFileOutlined",
  "AudioFileOutlined",
  "DepartmentOutlined",
  "UnplayedaudioOutlined",
  "PlayOutlined",
  "PauseOutlined",
  "RedoOutlined",
  "UndoOutlined",
  "StopOutlined",
  "FilterOutlined",
  "VideoOutlined",
  "WishListOutlined",
  "BackLogOutlined",
  "LastSprintOutlined",
  "ActiveSprintOutlined",
  "ClosedSprintOutlined",
  "TimeZoneOutlined",
  "FileOutlined",
  "UsersOutlined",
  "AttachmentOutlined",
  "PhoneOutlined",
  "HomeOutlined",
  "EmailOutlined",
  "PayslipOutlined",
  "ManageTaxOutlined",
  "ChangePasswordOutlined",
  "AnnouncementsOutlined",
  "LogoutOutlined",
  "TextOutlined",

  "APIOutlined",
  "SendRequestOutlined",
  "PlusOutlined",
  "SearchOutlined",
  "DoubleQuotesOutlined",
  "NumberedOutlined",
  "BulletOutlined",
  "LeftOutlined",
  "RightOutlined",
  "CenterOutlined",
  "JustifyOutlined",
  "StrikethroughOutlined",
  "TextColorOutlined",
  "BgColorOutlined",
  "FolderOutlined",
  "EyeOpenedOutlined",
  "SkypeOutlined",
  "TreeOutlined",
  "DashboardOutlined",

  "ZipFilled",
  "StoryFilled",
  "Folder0Filled",
  "Folder1Filled",
  "Folder2Filled",
  "Folder3Filled",
  "Folder4Filled",
  "Folder5Filled",
  "TestingFilled",
  "SDEFilled",
  "GrpupsFilled",
  "UploadFilled",
  "BudgetsFilled",
  "BugTrackingFilled",
  "DevFilled",
  "UatFilled",
  "PrdFilled",
  "PlusFilled",
  "AppLogoFilled",
  "LoaderFilled",
  "BugFilled",
  "ChangerequestFilled",
  "EpicFilled",
  "FeatureRequestFilled",
  "GoogleFilled",
  "ImprovementsFilled",
  "MicrosoftFilled",
  "QueryFilled",
  "SubtaskFilled",
  "PriorityFilled",
  "StatusFilled",

  "SupportFilled",
  "TaskFilled",
  "WishListFilled",
  "BackLogFilled",
  "LastSprintFilled",
  "GoalFilled",
  "ActiveSprintFilled",
  "ClosedSprintFilled",
  "RightArrowFilled",
  "UserFilled",
  "KanbanOutlined",
  "Avatar1Filled",
  "Avatar2Filled",
  "Avatar3Filled",
  "Avatar4Filled",
  "BusinessFilled",
  "BusinessProfileFilled",
  "PreferencesFilled",
  "LocationFilled",
  "BankFilled",
  "TaxFilled",
  "DiscountFilled",
  "PdfFilled",
  "ShareFilled",
  "PrintFilled",
  "EditFilled",
  "PreviewFilled",
  "TickFilled",
  "DotFilled",
  "CrossFilled",
  "ArrowFilled",
  "MenubarFilled",
  "CloseMenubarFilled",
  "DashboardFilled",
  "InboxFilled",
  "TimeSheetFilled",
  "PerformanceFilled",
  "GoogleMeetFilled",
  "CiscoWebexFilled",
  "ZoomFilled",
  "MicrosoftTeamsFilled",
  "SlackFilled",
  "SkypeFilled",
  "GoToMeetingFilled",
      
  "LineUpFilled",
  "ClockFilled",
  "ProfitFilled",
  "UsersFilled",
  "TaskClockCompltionFilled",
  "RevenueFilled",
  "ArrowLineUpFilled",
  "ArrowLineDownFilled",
  "BannerTwoTone",
  "AssignedTaskTwoTone",
  "AssigneeTwoTone",
  "DaysReminingTwoTone",
  "IssueRisedTwoTone",
  "LeaveTodayTwoTone",
  "MeetingsTwoTone",
  "OfficeTwoTone",
  "WishListTwoTone",
  "WorkFromHomeTwoTone",
  "EmptyTwoTone",
  "TableEmptyTwoTone",
  "InvoiceTempleteTwoTone",
  "WorkingTwoTone",
  "PageNotFoundTwoTone",
  "TotalrevenueTwoTone",
  "ProjectsTwoTone",
  "TimespentTwoTone",
  "ResourcesTwotone",
  "NetprofitTwotone",
  "Runwayicon",
  "Totalsalesrevenue",
  "Conversionrate",
  "Qualified",
  "Avgsales",
  "Clientretentionrate",
  "Newcontractsclosed",
  "Totalheadcount",
  "Deptutilization",
  "Avgskillgrowth",
  "Avgworkhours",
  "Productivityrate",
  "Talentretention",
  "Grossmargin",
  "Revenueperemployee",
  "Ebitdamargin",
  "Projectprofitability" &&
"Costutilization",
  "Cashrunway",
  "Totalapplication",
  "Interviewsscheduled",
  "Offersmade",
  "Offeracceptancerate",
  "Timetohire",
  "Costperhire",
  "Avgday",
  "Chance",
  "Riskinsales",
  "Riskintechroles",
  "Employeereferrals",
  "Newleadsadded",
  "Qualifiedleads",
  "Avgleadresponse",
  "Emailopenrate",
  "Conversioncall",
  "Highvalueprospects",
  "Linkedrate"
];

const IconGallery = () => {
  return (
    <div className={styles.gallery}>
      {iconNames.map((iconName, index) => (
        <div key={index} className={styles.iconItem}>
          <KoIcon name={iconName} width={24} height={24} />
          <KoText text={iconName} copyable={{ text: iconName }} />
        </div>
      ))}
    </div>
  );
};

export default IconGallery;
